'use strict';

import {changeLangToCurrent} from "../langSwitcher/langSwitcher";
import {TimesOfDay} from "../../liveAnimations/litemode/dayNight/TimesOfDay";
import {BuildingOutline} from "../../building/BuildingOutline";
import {Weather} from "../weather/Weather";
import axios from 'axios';
import { PublicLayers } from '../publicLayers/PublicLayers';
import { EnvironmentToggle } from '../../threejs/sceneBackground';
import { isMobile, isNoMenu, settingsData } from '../../../settings';
import {BaseElement} from "../../interfaces/BaseElement";
import {PopUpPage} from "../../interfaces/pages/PopUp";
import { FutureDevelopment } from '../futureDevelopment/FutureDevelopment';
import { Environment } from '../Environment/Environment';
import { Cookie } from '../../Cookie/Cookie';
import { OrbitDayAndNight } from '../../liveAnimations/DayNight/OrbitDayAndNight';
import { BmbyMode } from '../../mode/BmbyMode';
import { DayNightButton } from '../../threejs/DayNightButton/DayNightButton';
import { Range } from '../../interfaces/switchers/Range';
import {getTimestampForTime} from "../../../functions";

export class DisplayOptions {
  #element = null;
  #options = null;
  #weather = null;
  #timesOfDay = null;
  static isOpened = false;
  static scope = null;

  constructor(parent) {
    if (BmbyMode.active)
      return;

    this.#element = new BaseElement()
      .addClass('display-options', isMobile ?  null : 'background-backdrop-filter', isNoMenu ? 'no-menu-mode' : null);

    if (!isMobile) {
      const position = config.features?.weather?.position;
      switch (position) {
        case "left":
          this.#element.addClass('display-options--align-left');
          break;
        case "center":
          this.#element.addClass('display-options--align-center');
          break;
      }
    }

    if (config.features.weather.bg && !isMobile)
      this.#element.addStyle("background-color", config.features.weather.bg);

    this.#createDisplayOptionsHeader(this.#element.DOMElement);
    this.#createOptions();

    if (Environment.isActive()) {
      Environment.addLayers(this.#options.DOMElement);
    } else {
      this.publicLayers = new PublicLayers(this.#options.DOMElement);
    }

    this.orbitDayAndNight = null;
    EnvironmentToggle.scope?.addToDisplayOption(this.#options.DOMElement);
    if (!isMobile)
      new FutureDevelopment(this.#options.DOMElement).createSwitcher();

    this.#getData().then(() => {
        if (!this.data)
          return;

        this.#weather = new Weather(this.#element.DOMElement, 'display-options__weather-widget',this.data);
        if (TimesOfDay.active) {
          this.#timesOfDay = new TimesOfDay(this.#options.DOMElement, this.data);
        } else {
          EnvironmentToggle.scope.response = this.data;
        }
        
        if (Environment.fromBundle() && OrbitDayAndNight.isActiveAndSelected && !this.orbitDayAndNight) {
          this.orbitDayAndNight = new OrbitDayAndNight(this.#options.DOMElement,this.data);
        }

        setInterval(() => {
          this.#weather?.refreshTime();
          this.#timesOfDay?.refreshTime();
          this.orbitDayAndNight?.refreshTime();
        },1000);
        this.#addEventListenerToNeededElements();
    });

    if (!this.#isDisplayOptionsNeeded())
      return;

    this.#element.appendTo(parent);
    DisplayOptions.displayOptionsVisibility('hide');

    this.#showOnBoarding();
    DisplayOptions.scope = this;
  }

  #addEventListenerToNeededElements() {
    const listOfElementsSelectors = ['.display-options__header', '.display-options__weather-widget'];
    listOfElementsSelectors.forEach(element => {
      const currentElement = this.#element.DOMElement.querySelector(element);
      if (currentElement) {
        currentElement.addEventListener('click', this.#displayOptionsHeaderHandler.bind(this));
        currentElement.style.cursor = 'pointer';
      }
    });
  }

  async #getData() {
    const api = {
      "domain": "https://api.openweathermap.org/data/2.5/weather",
      "id": "4f74e2ec968c168e0a2c4ef5f8eb67d1",
      "units": "metric",
      "iconUrl": "https://openweathermap.org/img/wn/"
    };
    const apiUrl = `${api.domain}?lat=${config.localization.latitude}&lon=${config.localization.longitude}&units=${api.units}&appid=${api.id}`;
    const response = await axios.get(apiUrl);
    if (response.status !== 200) {
      this.data = {
        "coord": {
          "lon": config.localization.longitude,
          "lat": config.localization.latitude
        },
        "weather": [
          {
            "id": 800,
            "main": "Clear",
            "description": "clear sky",
            "icon": "01d"
          }
        ],
        "base": "stations",
        "main": {
          "temp": null,
          "feels_like": 20.06,
          "temp_min": 19.4,
          "temp_max": 21.01,
          "pressure": 1015,
          "humidity": 57,
          "sea_level": 1015,
          "grnd_level": 1011
        },
        "visibility": 10000,
        "wind": {
          "speed": 1.54,
          "deg": 0
        },
        "clouds": {
          "all": 0
        },
        "dt": 1743749701,
        "sys": {
          "type": 2,
          "id": 2092555,
          "country": "IL",
          "sunrise": getTimestampForTime(5, 0),
          "sunset": getTimestampForTime(19, 0)
        },
        "timezone": 10800,
        "id": 295548,
        "cod": 200
      }
    } else {
      this.data = await response.data;
    }
  }

  #isDisplayOptionsNeeded() {
    return (
      config.features.weather?.active ||
      config.features.weather?.widget ||
      this.#timesOfDay?.isActive
    );
  }

  #createOptions() {
    this.#options = new BaseElement()
        .addClass('display-options__options', 'display-options__options--collapsed');

    if (isMobile) {
      const displayOptionsPage = new PopUpPage('Public layers');
      displayOptionsPage.addClass('display-options-page');
      displayOptionsPage.addClass('hidden');
      displayOptionsPage.removeClass('background-backdrop-filter');
      displayOptionsPage.titleIcon = 'icon-tune';
      displayOptionsPage.contentElement.appendChild(this.#options.DOMElement);
    } else {
      this.#element.appendElement(this.#options.DOMElement);
    }

    BuildingOutline.addToDisplayOptions(this.#options.DOMElement);
  }

  #createDisplayOptionsHeader(parent) {
    const displayOptionsHeader = new BaseElement('span')
        .addClass('display-options__header')
        .appendTo(parent);
      if (!isMobile) {
        new BaseElement('span')
            .addClass('header__text', 'language-string')
            .innerHtml(changeLangToCurrent('Public layers'))
            .addAttribute('data-dictionary', 'Public layers')
            .appendTo(displayOptionsHeader.DOMElement);
        new BaseElement('span')
            .addClass('header__checker', 'icon-down2')
            .appendTo(displayOptionsHeader.DOMElement);
      } else {
        new BaseElement('span')
          .addClass('header__icon', 'icon-tune')
          .appendTo(displayOptionsHeader.DOMElement);
      }
  }

  #displayOptionsHeaderHandler(e) {
    if(e.target.closest('.switch-wrapp')) return;
    const optionsElement = document.querySelector('.display-options__options');
    if (isMobile) {
      DisplayOptions.displayOptionsVisibility('show');

      const displayOptionsPopUpPage = document.querySelector('.pop-up-page.display-options-page');
      displayOptionsPopUpPage.addEventListener('click', this.#mobileDisplayOptionsPageClickHandler.bind(this));
    } else {
      if (optionsElement.classList.contains('display-options__options--collapsed')) {
        if (settingsData.isConferenceHost) {
          optionsElement.addEventListener('transitionend',() => OrbitDayAndNight.turnOn(),{once: true});
        }
        DisplayOptions.displayOptionsVisibility('show');
      } else {
        DisplayOptions.displayOptionsVisibility('hide');
      }
    }
  }

  #mobileDisplayOptionsPageClickHandler(event) {
    if (
      event.target === document.querySelector('.pop-up-page.display-options-page') ||
      event.target.closest('button') ||
      event.target.closest('.switch') ||
      event.target.closest('.weather-state')
    ) {
      DisplayOptions.displayOptionsVisibility('hide');
      PopUpPage.hide();
    }
  }

  static displayOptionsVisibility(action) {
    const displayOptions = document.querySelector('.display-options');
    const displayOptionsElement = document.querySelector('.display-options__options');

    if (!displayOptions || !displayOptionsElement)
      return;

    switch (action) {
      case 'show':
        DisplayOptions.isOpened = true;
        DisplayOptions.#showDisplayOptions();
        if (isMobile) {
          document.querySelector('.display-options-page').classList.remove('hidden');
          PopUpPage.animation('show');
        } else {
          OrbitDayAndNight.turnOn();
        }

        break;
      case 'hide':
        DisplayOptions.isOpened = false;
        if (!isMobile) {
          if (DayNightButton.scope?.switcherState === 'day' && !config.features.dayNight.checked) {
            OrbitDayAndNight.turnOff();
            Weather.scope?.resetToDefault();
          }
        }

        DisplayOptions.hideDisplayOptions();

        break;
      case 'update':
        if (isMobile) {
          displayOptionsElement.style.removeProperty('max-height');
          break;
        }
        if (displayOptions.classList.contains('display-options--expanded')) {
          displayOptionsElement.style.maxHeight = displayOptionsElement.scrollHeight + 'px';
        }
        break;
      default:
        console.log('#displayOptionsVisibility default case');
        break;
    }
  }

  static #showDisplayOptions() {
    const displayOptions = document.querySelector('.display-options');
    const displayOptionsElement = document.querySelector('.display-options__options');
    const headerChecker = document.querySelector('.header__checker');

    if (!displayOptions || !displayOptionsElement || !isMobile && !headerChecker)
      return;

    DisplayOptions.calculateMaxHeight();

    displayOptionsElement.classList.remove('display-options__options--collapsed');
    displayOptions.classList.add('display-options--expanded');
    if (headerChecker)
      headerChecker.classList.add('rotate');
  }

  static hideDisplayOptions() {
    const displayOptions = document.querySelector('.display-options');
    const displayOptionsElement = document.querySelector('.display-options__options');
    const headerChecker = document.querySelector('.header__checker');

    if (!displayOptions || !displayOptionsElement || !isMobile && !headerChecker)
      return;

    if (!isMobile)
      displayOptionsElement.style.maxHeight = null;
    displayOptionsElement.classList.add('display-options__options--collapsed');
    displayOptions.classList.remove('display-options--expanded');
    if (headerChecker)
      headerChecker.classList.remove('rotate');
  }

  #showOnBoarding() {
    if (isMobile)
      return;

    const showed = Cookie.getCookie('displayOptionsOnBoarding');
    if (!showed) {
      Cookie.setCookie('displayOptionsOnBoarding','showed');
      DisplayOptions.displayOptionsVisibility('show');
      const interval = setInterval(() => {
        DisplayOptions.displayOptionsVisibility('update');
        if (!document.querySelector('#preloader_slider')) {
          clearInterval(interval);
          setTimeout(() => DisplayOptions.displayOptionsVisibility('hide'),2000);
        }
      },100);
    }
  }

  get displayOptions() {
    return this.#options.DOMElement;
  }

  static hide() {
    const displayOptionsEntities = document.querySelectorAll('.display-options');
    for (let i = 0; i < displayOptionsEntities.length; i++) {
      displayOptionsEntities[i].classList.add('hidden');
    }

    Weather.showed = false;

    if (Weather.selectedWeather) {
      Weather.effects[Weather.selectedWeather.id].disable();
    }
  }

  static show() {
    const displayOptionsEntities = document.querySelectorAll('.display-options');
    for (let i = 0; i < displayOptionsEntities.length; i++) {
      displayOptionsEntities[i].classList.remove('hidden');
    }

    Weather.showed = true;

    if (Weather.selectedWeather) {
      if (Weather.effects[Weather.selectedWeather.id].effect){
      }
      Weather.effects[Weather.selectedWeather.id].enable();
    }
  }

  static calculateMaxHeight() {
    const displayOptions = document.querySelector('.display-options');
    if (!displayOptions || isMobile)
      return;
    const optionsElement = displayOptions.querySelector('.display-options__options');
    const bottomNavBar = document.querySelector('.bottom__nav-bar');
    const bottomNavBarHeight = bottomNavBar ? bottomNavBar.getBoundingClientRect().height : 0;
    const bottomNavBarBottomOffset = bottomNavBar ? parseInt(getComputedStyle(bottomNavBar).bottom, 10) : 0;
    const displayOptionsHeight = displayOptions.getBoundingClientRect().height;
    const displayOptionsTopOffset = displayOptions.getBoundingClientRect().top;
    const gapBetweenOptionsAndBottomNavBar = 10;
    const displayOptionsArea = displayOptionsHeight + optionsElement.scrollHeight + displayOptionsTopOffset + gapBetweenOptionsAndBottomNavBar;
    const bottomNavBarAreaHeight = bottomNavBarHeight + bottomNavBarBottomOffset;

    if (displayOptionsArea > window.innerHeight - bottomNavBarAreaHeight) {
      const displayOptionsGap = parseInt(getComputedStyle(displayOptions).gap, 10);
      const offset = displayOptionsHeight + displayOptionsTopOffset + bottomNavBarAreaHeight + gapBetweenOptionsAndBottomNavBar + displayOptionsGap;
      optionsElement.style.maxHeight = window.innerHeight - offset + 'px';
      optionsElement.style.overflowY = 'auto';
    } else {
      optionsElement.style.maxHeight = optionsElement.scrollHeight + 'px';
      optionsElement.style.removeProperty('overflow-y');
    }
  }
}
